var page = 1;
var items_by_page = 9;
var close = 0;
var lastScrollTop = 0;
var allH = [];


function goPage( num ){

	var first_item = items_by_page * num;
	var last_item = first_item + items_by_page;
	$.each( $( ".press-item" ), function( index, value ){

		if( index < first_item )
			$( value ).css( "display", "none" );
		else if( index >= first_item && index < last_item )
			$( value ).css( "display", "block" );
		else
			$( value ).css( "display", "none" );


	} )

	return false;

}

function generatePaginator(){

	$( ".paginator" ).remove();

	var count = $('.press-item').length;
	var html = "<div class='paginator'>";
	var floor = count/items_by_page;
	//if( count % 5 == 0 ) floor -=1;
 	for( var i = 0 ; i <  floor ; i++ ){
		 if(i == 0){
			html += '<a href="#" class="paginator-click active" >' + '0'+ +(+i+1)+ '</a> ';
		 } else {
			html += '<a href="#" class="paginator-click" >' + '0'+ +(+i+1)+ '</a> ';
		 }
		
	}
	html += "</div>";

	$( "#pressContainer" ).append( html ); 
	let allPaginatorClick = document.getElementsByClassName('paginator-click');
	for(let t = 0; t < allPaginatorClick.length; t++){
		allPaginatorClick[t].addEventListener('click', function(e){
			e.preventDefault();
			let selector = t + 1;
			console.log(selector)
			goPage(t);
			for(let a = 0; a < allPaginatorClick.length; a++){
				if(allPaginatorClick[a] == this){
					this.classList.add('active')
				} else {
					allPaginatorClick[a].classList.remove('active')
				}
			}
		})
	}
	

}


function resizeWindow(){
	
	var tHeight = $(window).height() - 165;
	$('#home .top-content .header-img, #home .top-content .header-img .sym-slide').height(tHeight);
	
	if(document.getElementsByClassName('ui-datepicker-group').length > 0){
		calendarH();
	}
}

function scrollDown(){
	var top = $(document).scrollTop();
	if(!$('body.map').length > 0){
		if (top > 390) {
			$('#content .sub-menu').addClass('up');
		} else {
			$('#content .sub-menu').removeClass('up');
		}
	}
	if(top > 50){
		if(close == 0){
			$('#header .notice').fadeOut();
		}
		
	}else{
		if(close == 0){
			$('#header .notice').fadeIn();
		}
		
	}

		//check scroll down or up for header styles
		//console.log('ddd');
		let st = window.pageYOffset || document.documentElement.scrollTop;
		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				//	document.getElementsByClassName('header__logo').classList.remove('hidden');
					//document.getElementById('logo-color').classList.add('hidden');
	
					// document.getElementsByClassName('header__logo')[0].classList.add('hidden');
					// document.getElementsByClassName('logo-color')[0].classList.remove('hidden');
				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
					//const logo_scroll = document.querySelector('img.logo-scroll').dataset.scroll;
					//document.querySelector('.header__logo img').src = logo_scroll;
					//document.getElementsByClassName('header__logo').classList.add('hidden');
					//document.getElementById('logo-color').classList.remove('hidden');
				}
			}
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
				//document.getElementById('logo-color').classList.add('hidden');
			//	document.getElementsByClassName('header__logo')[0].classList.remove('hidden');
	//document.getElementsByClassName('logo-color')[0].classList.add('hidden');
	
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	
	
}

function scrollW(){


}

function _get_form_token(){
	$.get(
		site_url + '/ajax/functions.php?operation=_get_form_token',
		function(resp) {
			$("input[name=_token][type=hidden]").each( function(){
				this.value = resp
			})		
		}		
	);
}

$(window).on('load', function() {
	_get_form_token();
	resizeWindow();

	const pathname = window.location.pathname;
	if(pathname.indexOf('/givethanks')>-1){
        $('input[name=email_address]').val('reservations@hoteldrisco.com');
    }

   	//Slick Slider
	$('.sym-slides').slick();
	$('#home .main-content .home-reasons .reasons .block').slick({
		arrows : false,
		dots : true,
		fade : true,
		adaptiveHeight: true,
		accessibility: true
	});
	$('#home .main-content .home-specials .container .block').slick({
		arrows : false,
		dots : true,
		fade : true,
		accessibility: true
	});
	$('#home .main-content .home-reasons .amenities .wrap').slick({
		arrows : false,
		dots : true,
		fade : true,
		accessibility: true
	});
	$('#content #bottom-content .shortcode .reviews-block .testimonials-block ul.wrap').slick({
		arrows : false,
		dots : true,
		fade : true,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 8000,
		accessibility: true
	});
	$('#content #bottom-content .shortcode .reviews-block .rates-block ul.wrap').slick({
		arrows : false,
		dots : true,
		fade : true,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 8000,
		accessibility: true
	});
	$('body.reviews #content #bottom-content .blue-block article').wrapAll('<div class="wrap"></div>');
	$('body.reviews #content #bottom-content .blue-block .wrap').slick({
		arrows : true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		accessibility: true
	});
	//Add cero to slick dots
	$('ul.slick-dots li').each(function(){
		var current = parseInt($(this).find('button').html());
		var newT = '';
		if(current < 10){
			var newT = '0' + current;
			$(this).find('button').html(newT);
		}
	});
	
	
	$('.list li .image').slick({
		arrows: true,
		fade:true,
		accessibility:false
	});
	
	$('.header-img').slick({
		arrows: false,
		autoplay:true,
		autoplaySpeed:4000,
		fade:true,
		accessibility:false
	});

});

$(document).ready(function () {


	//if anchor in url
	let pagePath = window.location.href;
	if (pagePath.indexOf("#") > -1) {
		let pageUrl = pagePath.split("#");
		animateTo(pageUrl[1]);
	}


	$('.benefits-block').click(function(){
		if(!$(this).hasClass('open')){
			$(this).addClass('open');
			$('.benefits-block__list').slideDown();
		} else {
			$(this).removeClass('open');
			$('.benefits-block__list').slideUp();
		}
	});

	/*document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function(){
		if(!document.getElementsByClassName('booking-block')[0].classList.contains('open')){
			document.getElementsByClassName('booking-block')[0].classList.add('open');
			document.getElementById('header').classList.add('booking-open');
			this.classList.add('open');
			this.innerHTML = 'Close X';
		} else {
			document.getElementsByClassName('booking-block')[0].classList.remove('open');
			document.getElementById('header').classList.remove('booking-open');
			this.classList.remove('open');
			this.innerHTML = 'Check Availability';
		}
	});*/



	
	//Call function with browser is resized.
	var tHeight = $(window).height() - 165;
	$('#home .top-content .header-img, #home .top-content .header-img .sym-slide').height(tHeight);
    $(window).resize(function (event) {
		//resizeWindow();
		var tHeight = $(window).height() - 165;
		$('#home .top-content .header-img, #home .top-content .header-img .sym-slide').height(tHeight);
   });

   //Acts when scroll down page.
   $(window).scroll(function (event) {
	   scrollDown();
   });
   scrollDown();
	
	$('#header .notice .close').click(function(){
		$('#header .notice').fadeOut();
		close = 1;
	});




	
	//Pages header image animation
	if(!$('body#home').length > 0){
		$('#content #top-content .header-img').addClass('show');
	}
	
	
	//Gallery
	$('#content .main-content .home-gallery .block a.mini').wrapAll('<div class="wrap"></div>');
	$('#content .main-content .home-gallery .block a span').each(function(){
		$(this).wrapAll('<div class="block-wrap"><div class="block-inner"><div class="icon"></div></div></div>');
	});

	//pop in left .special-popin
	$('.special-popin__call').click(function(){
		$('.special-popin__content').addClass('active');
	});
	$('.special-popin__content .closepopin').click(function(){
		$('.special-popin__content').removeClass('active');
	});
	$('.special-popin__content a').click(function(){
		ga('send', 'event', 'popup', 'click', 'budbreak-btn');
	});

	$('.btn-popin').click(function(){
		$('.content-popin').addClass('open');
	});
	$('.close-popin').click(function(){
		$('.content-popin').removeClass('open');
	});


	// Main Nav Dropdown
    $("#primary-nav li").hover(function(){

        $(this).addClass("hover");
        $('ul.submenu',this).fadeIn(200);

    }, function(){

        $(this).removeClass("hover");
        $('ul.submenu',this).fadeOut(200);

	});
	
	//pop in left .special-popin
	$('.special-popin__call').click(function(){
		$('.special-popin__content').addClass('active');
	})
	$('.special-popin__content .closepopin').click(function(){
		$('.special-popin__content').removeClass('active');
	})
	$('.special-popin__content a').click(function(){
		ga('send', 'event', 'popup', 'click', 'budbreak-btn');
	})

	//Home page scroll down arrow. If present.
	$('.arrow-home-1').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()*1},
	        800, 'easeOutExpo');
	});
	//home benefits
	$('#home .top-content .benefits .title').click(showBenefits);

	//Event Tracking
    $('.book-now').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });

	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	
    
    //home map interaction
    $('#home .main-content .home-map .pins .pin').click(function(){
	    var current = $(this).attr('data');
	    $('#home .main-content .home-map .pin').removeClass('active');
	    $(this).addClass('active');
	    $('#home .main-content .home-map .info .pin[data="'+current+'"]').addClass('active');
    });
    
    
    //ROOMS
    if($('body.rooms').length > 0){
	    $('#content #bottom-content .blue-block').insertBefore($('.shortcode'));
    }
    
    //rooms amenities
    if($('body.rooms #content #bottom-content .blue-block .block').length > 0){
	    

 		$('body.rooms #content #bottom-content .blue-block .block ul li:empty').remove();
	    var totalLi = $('body.rooms #content #bottom-content .blue-block .block ul').children().length;
	    var cont = 0;
	    $('body.rooms #content #bottom-content .blue-block .block ul li').each(function(){
		    if( cont < totalLi){
			    $(this).addClass('checked');
			    cont = cont + 2;
		    }
	    });
	    $('body.rooms #content #bottom-content .blue-block .block li.checked').wrapAll('<ul class="lastul"></ul>');
	    $('.lastul').insertAfter($('.firstul'));
	    $('body.rooms #content #bottom-content .blue-block .block li').removeClass('checked');
	    $('body.rooms #content #bottom-content .blue-block .block').clone().insertAfter($('body.rooms #content #bottom-content .blue-block .title'));
	    var j = 1;
	    $('body.rooms #content #bottom-content .blue-block .block:last-child ul.firstul li').each(function(){
		    if(j > 3){
			    $(this).addClass('toremove');
		    }
		    j++;
	    });
	    var j = 1;
	    $('body.rooms #content #bottom-content .blue-block .block:last-child ul.lastul li').each(function(){
		    if(j > 3){
			    $(this).addClass('toremove');
		    }
		    j++;
	    });
	    $('body.rooms #content #bottom-content .blue-block .block:last-child ul li.toremove').remove();
	    
	    $('body.rooms #content #bottom-content .blue-block .container .col-md-8').append('<div class="moreamenities"></div>');
	    
	    $('.moreamenities').click(showAmenities);
    }
    //rooms filter
    
    if($('#content #bottom-content .shortcode .accommodations .filter').length > 0){
	    setTimeout(function(){
		    $('#content #bottom-content .shortcode .list li[data="suite"]').addClass('no-active');
	    }, 1000);
    }
    $('#content #bottom-content .shortcode .accommodations .filter .item').click(function(){
	    var current = $(this).attr('data');
	    $('#content #bottom-content .shortcode .accommodations .filter .item').removeClass('active');
	    $(this).addClass('active');
	    $('#content #bottom-content .shortcode .list li').addClass('no-active');
	    $('#content #bottom-content .shortcode .list li[data="'+current+'"]').removeClass('no-active');
    });
	
	//if there is more content after content div
	$('body.services-and-amenities .list').insertAfter($('body.services-and-amenities #bottom-content .content'));
	if($('.after-content').length > 0){
		if($('body.services-and-amenities')){
			$('.after-content').insertBefore($('.list'));
		}else{
			$('#bottom-content .content .after-content').insertAfter($('#bottom-content .content'));
		}
		$('#bottom-content .after-content').wrapInner('<div class="container"></div>');
		
	}
	
	//Specials content
	$('#content .list .item').each(function(){
		if($(this).find('.desc').children().length > 1){
			$(this).find('.desc').children().hide();
			$(this).find('.desc p:first-child').show();
			if($(this).find('.book-now').length > 0){
				$('<div class="seeMore">Read More</div>').insertAfter($(this).find('.book-now'));
			} else{
				$('<div class="seeMore">Read More</div>').insertAfter($(this).find('.desc'));
			}
			
		}
	});
	$('.seeMore:not(.amenities)').click(showMore);
	
	$('.seeMore.amenities').click(showMoreA);
	
	
	//remove see more fuctionality in san francisco page
	$('.san-francisco #content .list li.deal, #content .list .item').each(function(){
		if($(this).find('.desc').children().length > 1){
			$(this).find('.desc').children().show();
			$(this).find('.seeMore').hide();		
		}
	});

	
	
	if($('body.sitemap').length > 0){
		$('#content #top-content .header-img img').attr('src', site_url + 'assets/images/sitemap-img-header.jpg');
	}
	
	var siteli = $('ul.global-sitemap > li').length;
	var cont = 0;
	$('ul.global-sitemap > li:not(.checked)').each(function(){
		if(cont < siteli){
			$(this).addClass('checked');
		}
		cont = cont + 2;
	});
	$('ul.global-sitemap > li.checked').wrapAll('<div class="col-md-4 col-md-offset-3"></div>');
	$('ul.global-sitemap > li:not(.checked)').wrapAll('<div class="col-md-4"></div>');
	$('ul.global-sitemap > li').removeClass('checked');
	
	if($('.global-sitemap').length > 0){
		$('.global-sitemap').wrap($('<div class="container"></div>'));
		$('.global-sitemap').addClass('clearfix');
		$('#content #bottom-content .intro .title').html($('#content #bottom-content h1').html());
		$('#content #bottom-content h1').remove();
	}
	$('ul.global-sitemap li ul li').each(function(){
		if($(this).find('a').text() == $(this).parent().prev('a').text()){
			//$(this).addClass('target');
			$(this).find('a').html('Overview');
		}
	});
	
	//rooms listsnextAll()
	if($('body.packages').length > 0){
		
		var pathname = window.location.href;
		if(pathname.indexOf("#") != -1){
			var urlpage = pathname.split("#");
			var rtarget = $('#'+urlpage[1]).position().top + 300;
			//var rtarget = $('#bottom-content').position().top;;
			//console.log(rtarget);
			$('body, html').animate({ scrollTop: rtarget }, 800, 'easeOutExpo');
		}
		

	
	}
	
	if($('body.map').length > 0){
		// Map: Return to previous page button. Change body id to match map template's name.
		$('body.map #content .sub-menu').addClass('up');
	}
	
	//Meetings and Events page
	if($('body.meetings-and-events').length > 0){
		$('.white-block').insertBefore($('.blue-block .col-md-8'));
	}
	
	//fancybox ifram to 100%
	$('[data-fancybox="image"]').fancybox({
		fullScreen : {
		    autoStart: true
		}
	});

	//Remove atr
	$('#third-nav').removeAttr('aria-labelledby');
	$('#third-nav').removeAttr('aria-label');

	//Paginator Press Page
	generatePaginator();
	goPage(0);
	
	// Run funtion to change labels on specials
	specialsBtnLabel();

	setTimeout(function(){
		if($('.topalert').length > 0){
			$('body').addClass('withalert');
		}
	},600);
	
});



function navisEmailSignup(formID) {

	$.post(site_url + 'ajax/emailsignup.php',$("#" + formID).serialize(), function(data){
		if(data.error) {
			$("#email-error").html(data.msg);

		} else {
			//ga('send', 'event', 'form', 'click', 'specials');
			$("#"+formID).html('<p>Thank You</p>');

		}
	},'json');

}

function showBenefits(){
	$('#home .top-content .benefits').addClass('open');
	$('#home .top-content .benefits .title').unbind('click');
	$('#home .top-content .benefits .title').click(hideBenefits);
}
function hideBenefits(){
	$('#home .top-content .benefits').removeClass('open');
	$('#home .top-content .benefits .title').unbind('click');
	$('#home .top-content .benefits .title').click(showBenefits);
}
function showMore(){
	$(this).parent().find('.desc').children().slideDown(600);
	$(this).parents().eq(2).addClass('open');
	$(this).html('hide Details');
	$(this).unbind('click');
	$(this).click(hideMore);
}
function hideMore(){
	$(this).parents().eq(2).removeClass('open');
	$(this).parent().find('.desc').children().fadeOut(300);
	$(this).parent().find('.desc').children().first().fadeIn(600);
	
	$(this).html('Read More');
	$(this).unbind('click');
	$(this).click(showMore);
}
function showAmenities(){
	$(this).addClass('up');
	$('body.rooms #content #bottom-content .blue-block .block:nth-child(3)').fadeOut(500);
	$('body.rooms #content #bottom-content .blue-block .block:nth-child(2)').slideDown(500);
	$(this).unbind('click');
	$(this).click(hideAmenities);
}
function hideAmenities(){
	$(this).removeClass('up');
	$('body.rooms #content #bottom-content .blue-block .block:nth-child(3)').fadeIn(500);
	$('body.rooms #content #bottom-content .blue-block .block:nth-child(2)').slideUp(500);
	$(this).unbind('click');
	$(this).click(showAmenities);
}

function showMoreA(){
	$(this).prev('.amenities').slideDown();
	$(this).parents().eq(2).addClass('open');
	$(this).html('hide Details');
	$(this).unbind('click');
	$(this).click(hideMoreA);
}
function hideMoreA(){
	$(this).prev('.amenities').slideUp();
	$(this).parents().eq(2).removeClass('open');
	$(this).html('Read More');
	$(this).unbind('click');
	$(this).click(showMoreA);
}

// function to change labels on specials
function specialsBtnLabel(){
	var buttons = document.querySelectorAll('.specials .book-now.btn');
	for (var button of buttons) {
		var target = button.getAttribute('href');
		var label = 'Know More';
		button.classList.add('flex-btn');
		if( target.indexOf('synxis') >= 0 ){
			label = '<span>Check Availability</span>';
		}else if( target.indexOf('tel:') === 0 ){
			button.classList.add('tel-btn');
			label = '<span>Call to Book</span><em>(800) 634-7277</em>'
		}
		button.innerHTML = label;
	}
}






//datepicker calendar 



$(document).ready(function () {

	var start = $('#arriveInput').attr('value');
	var end = $('#departureInput').attr('value');
	var firstClick = 0; 

	var limitDate = $('#limitDate').attr('value').split(',');

	$("#datesCalendar").datepicker({
		minDate: start,
		numberOfMonths:2,
		dateFormat: 'yy/mm/dd',
		maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
		beforeShowDay:function(date){

			$.datepicker._defaults.dateFormat = "yy/mm/dd";
			var startDate = $.datepicker.parseDate('yy/mm/dd', start);
			var endDate = $.datepicker.parseDate('yy/mm/dd', end);
			
			if(date.getTime() == startDate.getTime()){
				return[true,"start-day"];
			} else {
				if(date.getTime() == endDate.getTime()){
					return[true,"end-day"];
				} else {
					if(date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()){
						return[true,"days"];
					} else {
						return[true,""];
					}
				}
			}
		},
		onSelect: function(date){
			var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

			if(firstClick == 0){
				start = date;
				end = date;
				firstClick = 1;
			} else {
				if(selectedDate <= start){
					end =  start;
					start = date;  
				} else {
					end =  date; 
				}
				firstClick = 0;
			}

			$('#arriveInput').attr('value',start);
			$('#departureInput').attr('value',end);
		},
		onChangeMonthYear: function(){
			setTimeout(function(){
				calendarH();
			},80)
		}
	});

	calendarH();

	//booking selectors change for adults and children
	let allSelectors = document.getElementsByClassName('js-selector');
	let allSelectorsLength = allSelectors.length;
	for(let t=0; t < allSelectorsLength; t++){
		allSelectors[t].addEventListener('click', function(){
			let movement = this.getAttribute('data');

			

			if(movement == 'down'){
				let SelectorNumber = parseInt(this.nextElementSibling.innerHTML,10);
				SelectorNumber--;
				if(SelectorNumber >= 0){
					this.nextElementSibling.innerHTML = '0' + SelectorNumber;
					$('input[name="'+this.nextElementSibling.getAttribute('data')+'"]').attr('value', SelectorNumber);
				}
			} else {
				let SelectorNumber = parseInt(this.previousElementSibling.innerHTML,10);
				SelectorNumber++;
				if(this.previousElementSibling.getAttribute('data') == 'adult'){
					var selectorLimit = 4;
					
				} else {
					var selectorLimit = 3;
					
				}
				if(SelectorNumber <= selectorLimit){
					this.previousElementSibling.innerHTML = '0' + SelectorNumber;
					$('input[name="'+this.previousElementSibling.getAttribute('data')+'"]').attr('value', SelectorNumber);
				}
			}

		});
	}





		
		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});


		//Check in and check out datepicker for booking engine
		$( "#CheckInLanding" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOutLanding" ).datepicker( "setDate", newDate );
				$( "#CheckOutLanding" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOutLanding" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');


});
function calendarH() {
	//console.log('cambia');
	allH = [];
	$('.ui-datepicker-group').each(function(){
		$(this).css('height','auto');
		allH.push($(this).height());
	});
	let tallestP = allH.reduce(function(a,b){
		return a > b ? a : b;
	},{});
	$('.ui-datepicker-group').each(function(){
		$(this).css('height',tallestP + 10 + 'px');
	});
}



//single form function
function Gratitude(){
	document.getElementsByClassName('text-top')[0].classList.add('submitted')
}

//vanilla js scroll TO animation
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 2000;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

(function() {

	if (document.getElementById("ot-sdk-btn") && document.getElementById("tertiary-navigation")) {
        document.getElementById("tertiary-navigation").appendChild(document.getElementById("ot-sdk-btn"))
    }

	//vanilla JS fancybox
	let footerSignUp = document.querySelector('.footer__sign.content-signup');
	footerSignUp.style.cursor = 'pointer';

	if(document.getElementsByClassName('footer__sign content-signup').length > 0){
		document.getElementsByClassName('footer__sign content-signup')[0].addEventListener('click', function(e){
			e.preventDefault();
			document.getElementById('signupContainer').classList.add('active')
		})
		document.getElementsByClassName('js-signup-close')[0].addEventListener('click', function(){
			document.getElementById('signupContainer').classList.remove('active')
		})
	}
	if(document.getElementsByClassName('form-disclaimer ').length > 0){
		let allDisclaimers = document.getElementsByClassName('form-disclaimer ');
		let formWrapper = document.getElementsByClassName('form-module')[0];
		for(let t = 0; t < allDisclaimers.length ; t++ ){
			formWrapper.appendChild(allDisclaimers[t])
		}
	}

		//custom popin 
		let topBanner = document.querySelector('.custom-popin .top-popin');
		let bottomBanner = document.querySelector('.custom-popin .bottom-popin');
		let closeBottomBanner = document.querySelector('.custom-popin .bottom-popin__close');
	
		document.addEventListener('DOMContentLoaded', function(){
			if( topBanner.classList.contains('no-visible') ) {
				console.log(topBanner);
				topBanner.classList.remove('no-visible');
			}
	
			topBanner.addEventListener('click', function(){
				if( bottomBanner.classList.contains('no-visible')  ){
					topBanner.classList.add('no-visible');
					bottomBanner.classList.remove('no-visible'); 
				}
			});
	
			closeBottomBanner.addEventListener('click', function (){
				bottomBanner.classList.add('no-visible');
			});
	
		});
	
}());